<template>
  <div id="app">
    <Header></Header>
    <main>
      <CenterWrapper>
        <router-view/>
      </CenterWrapper>
    </main>
  </div>
</template>

<script>
import CenterWrapper from '@/components/CenterWrapper';
import Header from '@/components/Header';

export default {
  name: 'App',
  components: {
    Header,
    CenterWrapper,
  },
};
</script>

<style>
@import './app.css';
</style>



// WEBPACK FOOTER //
// src/App.vue